import { render, staticRenderFns } from "./christoph-mickel.vue?vue&type=template&id=834872b2&scoped=true"
import script from "./christoph-mickel.vue?vue&type=script&lang=js"
export * from "./christoph-mickel.vue?vue&type=script&lang=js"
import style0 from "./christoph-mickel.vue?vue&type=style&index=0&id=834872b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834872b2",
  null
  
)

export default component.exports